module.exports = __webpack_public_path__ + "media/images/rectangle-fcfd7e58557dbeee5235df5c61d19c36.png";